export function match(param: string) {
	return param === "layers" || param === "monitors" || param === "alerts";
}
